<div class="calendar-container">
  <!-- Header -->
  <div class="calendar-header">
    <button class="nav-btn" (click)="prevMonth()">&#10094;</button>
    <div class="calendar-title">{{ getMonthYearLabel() }}</div>
    <button class="nav-btn" (click)="nextMonth()">&#10095;</button>
  </div>

  <!-- Weekdays -->
  <div class="calendar-grid weekday-header">
    <div *ngFor="let day of ['Sun','Mon','Tue','Wed','Thu','Fri','Sat']">{{ day }}</div>
  </div>

  <!-- Calendar body -->
  <div class="calendar-grid">
    <ng-container *ngFor="let week of weeks">
      <ng-container *ngFor="let day of week">
        <div class="day-cell">
          <div class="cell-inner">
            <div class="date-number" [class.muted]="day.getMonth() !== currentMonth">
              {{ day.getDate() }}
            </div>

            <ng-container *ngFor="let range of getUnavailabilityForDay(day)">
              <div
                class="{{ getBarClass(day, range) }}"
                [matTooltip]="getTooltipText(range)"
                [matTooltipClass]="custom-tooltip"
                matTooltipPosition="above"
              >
                {{ getBarText(day, range) }}
              </div>

              <div *ngIf="hoveredRange === range" class="custom-tooltip-box">
                <b>{{ formatDay(range.from) }}</b>, {{ formatTime(range.from) }}
                &nbsp;–&nbsp;
                <b>{{ formatDay(range.to) }}</b>, {{ formatTime(range.to) }}
              </div>
            </ng-container>
          </div>
        </div>
      </ng-container>
    </ng-container>
  </div>
</div>
